import React from 'react';

import { Typography, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import * as S from './styles';

/**
 * LEGENDA (error)
 *
 * (1) Divergência encerrante
 * (2) Atualização de encerrante
 * (3) Divergência encerrante do turno anterior
 */
export default function Bicos({
  bico,
  sending,
  onForm,
  error,
  position,
  close,
}) {
  React.useEffect(() => {
    if (sending) {
      onForm({ position, error });
      close();
    }
  }, [sending]);

  if (error === 1)
    return (
      <S.Wrapper>
        <Typography>
          {t('s.operacao.turno.encerrantemecanicodivergente').replace(
            '%s',
            bico.idbico
          )}
        </Typography>

        <TextField
          fullWidth
          disabled
          label={t('s.operacao.turno.encerrantemecanico')}
          size="small"
          variant="outlined"
          value={number(bico.encerrantedigitadobico, 1)}
        />
      </S.Wrapper>
    );

  if (error === 2)
    return (
      <S.Wrapper>
        <Typography>
          {t('s.operacao.turno.erroatualizacaoencerrante').replace(
            '%s',
            bico.idbico
          )}
        </Typography>
      </S.Wrapper>
    );

  return (
    <S.Wrapper>
      <Typography>
        {t('s.operacao.turno.divergenciaencerranteturnoanterior').replace(
          '%s',
          bico.idbico
        )}
      </Typography>
    </S.Wrapper>
  );
}

Bicos.propTypes = {
  bico: PropTypes.objectOf(
    PropTypes.shape({
      idbico: PropTypes.number,
      encerrantedigitadobico: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    })
  ),
  sending: PropTypes.bool.isRequired,
  onForm: PropTypes.func.isRequired,
  error: PropTypes.number,
  position: PropTypes.number,
  close: PropTypes.func.isRequired,
};

Bicos.defaultProps = {
  bico: {
    idbico: 0,
    encerrantedigitadobico: 0,
  },
  error: 1,
  position: 0,
};
